import {RUTUBE_HOST} from 'components/VideoRutube/constants';
import {TVideoId} from 'components/VideoRutube/type';

export const getVideoSrc = (videoId: TVideoId) => `${RUTUBE_HOST}/play/embed/${videoId}`;
